module.exports = __webpack_public_path__ + "img/icon-sb-outside-drop-off-icon-100x67-v1.144ca68.svg";